import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";

export class StarkNet extends VisualizerBase {
    // readonly idTriangle: string;
    // readonly idSquare: string;
    // readonly idFiveStar: string;
    // readonly idHexagram: string;

    constructor(_placeholderMode: boolean = false) {
        super("starknet", _placeholderMode);

        // this.idTriangle = `triangle_${this.chainIdName}`;
        // this.idSquare = `square_${this.chainIdName}`;
        // this.idFiveStar = `fiveStar_${this.chainIdName}`;
        // this.idHexagram = `hexagram_${this.chainIdName}`;
    }

    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const triangleLength = 75;
        const halfTriangleLength = 37.5;
        const sr3 = Math.sqrt(3);
        const sr3HTL = sr3 * halfTriangleLength;

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        if(!coreMode) {
            const idOB = `circleOutbounding_${this.chainIdName}`;
            const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
            const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
            obCircle.id = idOB;
            obCircle.setAttribute("d", `${dOB}`);
            defs.appendChild(obCircle);
        }

        const points: Array<Point> = [ new Point(0, 0),
            new Point(-halfTriangleLength, -sr3HTL),
            new Point(0, -sr3HTL * 2),
            new Point(halfTriangleLength, -sr3HTL)
        ];
        const polygonId = `polygon_60deg_75_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        const triangleId = `triangle_${this.chainIdName}`;
        const triangleData = `M14.390998,5.0229993L9.5249989,13.579998 4.7309896,22.013998 14.400001,22.013998 24.049999,22.013998 19.280009,13.681999z M14.400001,0L21.600001,12.600998 28.800001,25.013998 14.400001,25.013998 0,25.013998 7.2000005,12.505999z`;
        const triangle = SvgUtils.createPath2(triangleId, triangleData, true, `translate(10,13.62) scale(1.3)`, "", "", 0);
        defs.appendChild(triangle);

        svg.appendChild(defs);
        
        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // polygon-1
        this.addUsePartToGroup(group, polygonId, ``, this.getColorHex(1, 2, 3), "", 0);
        // polygon-2
        this.addUsePartToGroup(group, polygonId, `rotate(72,0,0)`, this.getColorHex(4, 5, 6), "", 0);
        // polygon-3
        this.addUsePartToGroup(group, polygonId, `rotate(144,0,0)`, this.getColorHex(7, 8, 9), "", 0);
        // polygon-4
        this.addUsePartToGroup(group, polygonId, `rotate(216,0,0)`, this.getColorHex(10, 11, 12), "", 0);
        // polygon-5
        this.addUsePartToGroup(group, polygonId, `rotate(288,0,0)`, this.getColorHex(13, 14, 15), "", 0);
        
        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);

        const group2 = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // TODO: 需要调整4个三角形的位置
        // 4 triangles on 4 corners
        const angle1 = this.placeholderMode ? 0 : parseInt(this.hexArray[16], 16);
        const colorTriangle1 = this.getColorHex(17, 18, 19);
        const x1 = 10, y1 = 10;
        const transform1 = `rotate(${angle1},${37.5+x1},${37.5+y1}) translate(${x1} ${y1})`;
        this.addUsePartToGroup(group2, triangleId, transform1, colorTriangle1, "", 0);

        const angle2 = this.placeholderMode ? 0 : parseInt(this.hexArray[20], 16);
        const colorTriangle2 = this.getColorHex(21, 22, 23);
        const x2 = size - 50 -10, y2 = 10;
        const transform2 = `rotate(${angle2},${37.5+x2},${37.5+y2}) translate(${x2} ${y2})`;
        this.addUsePartToGroup(group2, triangleId, transform2, colorTriangle2, "", 0);

        const angle3 = this.placeholderMode ? 0 : parseInt(this.hexArray[24], 16);
        const colorTriangle3 = this.getColorHex(25, 26, 27);
        const x3 = 10, y3 = size - 70 -10;
        const transform3 = `rotate(${angle3},${37.5+x3},${37.5+y3}) translate(${x3} ${y3})`;
        this.addUsePartToGroup(group2, triangleId, transform3, colorTriangle3, "", 0);

        const angle4 = this.placeholderMode ? 0 : parseInt(this.hexArray[28], 16);
        const colorTriangle4 = this.getColorHex(29, 30, 31);
        const x4 = size - 50 -10, y4 = size - 70 -10;
        const transform4 = `rotate(${angle4},${37.5+x4},${37.5+y4}) translate(${x4} ${y4})`;
        this.addUsePartToGroup(group2, triangleId, transform4, colorTriangle4, "", 0);

        svg.appendChild(group2);
        return svg;
    }

}